import {
  APP_LOAD,
  REDIRECT,
  LOGOUT,
  ARTICLE_SUBMITTED,
  SETTINGS_SAVED,
  LOGIN,
  LOGIN_PAGE_VERIFY_PIN_CODE,
  VERIFY_USER_PIN,
  REGISTER,
  DELETE_ARTICLE,
  ACCOUNT_GO,
  ACCOUNT_RAW_GO,
  COIN_TRANSACTION_GO,
  ARTICLE_PAGE_UNLOADED,
  EDITOR_PAGE_UNLOADED,
  HOME_PAGE_UNLOADED,
  PROFILE_PAGE_UNLOADED,
  PROFILE_FAVORITES_PAGE_UNLOADED,
  SETTINGS_PAGE_UNLOADED,
  LOGIN_PAGE_UNLOADED,
  REGISTER_PAGE_UNLOADED,
  ON_GUEST,
  USER_CREATE,
  ASYNC_START,
  ASYNC_END,
  CHANGE_DATE_STRINGS,
  GENERATE_SIGNATURE,
  CONTRACT_CREATE,
  CONTRACT_UPDATE,
  MASTER_ACCOUNT_CREATE,
  MASTER_ACCOUNT_UPDATE,
  MASTER_ACCOUNT_MINT,
  CHAT_CHANNEL_CREATE,
  CHAT_CHANNEL_UPDATE,
  CHAT_CHANNEL_DELETE,
  CHAT_POST_DELETE,
  RATE_CREATE,
  RATE_UPDATE,
  TOKEN_CREATE,
  TOKEN_UPDATE,
  TOKEN_APPROVE,
  TOKEN_REJECT,
  TOKEN_PAUSE,
  TOKEN_UNPAUSE,
  TOKEN_CREATION_FEE_UPDATE,
  ACCOUNT_CREATE,
} from '../constants/actionTypes';

const defaultState = {
  appName: 'Admin Console',
  token: null,
  viewChangeCounter: 0
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case APP_LOAD:
      return {
        ...state,
        token: action.token || null,
        appLoaded: true,
        countries: action.payload[0] ? action.payload[0] : null,
        currentUser: action.payload[1] ? action.payload[1].user : null
      };
    case REDIRECT:
      return { ...state, redirectTo: null }
    case ON_GUEST:
      return { ...state, redirectTo: '/login' }
    case ACCOUNT_GO:
      let url = !action.raw ? `/accounts/${action.payload}` : `/accounts/raw/${action.payload}`
      return {
        ...state,
        redirectTo: url
      }
    case COIN_TRANSACTION_GO:
      return { ...state, redirectTo: '/coins/transactions/' + action.payload }
    case LOGOUT:
      return { ...state, redirectTo: '/', token: null, currentUser: null };
    case ARTICLE_SUBMITTED:
      const redirectUrl = `/article/${action.payload.article.slug}`;
      return { ...state, redirectTo: redirectUrl };
    case SETTINGS_SAVED:
      return {
        ...state,
        redirectTo: action.error ? null : '/',
        currentUser: action.error ? null : action.payload.user
      };

    case USER_CREATE:
      return {
        ...state,
        redirectTo: action.error ? null : '/users'
      };
    case LOGIN:
      let redirectTo = null
      if (action.payload && action.payload.user) {
        if (action.payload.user.pin_enabled) {
          redirectTo = 'verifypin'
        } else if (action.payload.user.token) {
          redirectTo = '/'
        } else {
          redirectTo = 'Verification'
        }
      }
      return {
        ...state,
        token: action.error ? null : action.payload.user ? action.payload.user.token : null,
        currentUser: action.error ? null : action.payload.user ? action.payload.user : null,
        redirectTo: redirectTo,
      }
    case LOGIN_PAGE_VERIFY_PIN_CODE:
      return {
        ...state,
        token: action.error ? null : action.payload.user.token,
        currentUser: action.error ? null : action.payload.user,
        redirectTo: action.error ? null : '/',
      }
    case VERIFY_USER_PIN:
      return {
        ...state,
        currentUser: action.error ? state.currentUser : action.payload.user,
        redirectTo: action.error ? null : '/',
        errors: action.error ? action.payload.error : null,
      }
    case REGISTER:
      return {
        ...state,
        redirectTo: action.error ? null : '/',
        token: action.error ? null : action.payload.user.token,
        currentUser: action.error ? null : action.payload.user
      };
    case DELETE_ARTICLE:
      return { ...state, redirectTo: '/' };
    case ARTICLE_PAGE_UNLOADED:
    case EDITOR_PAGE_UNLOADED:
    case HOME_PAGE_UNLOADED:
    case PROFILE_PAGE_UNLOADED:
    case PROFILE_FAVORITES_PAGE_UNLOADED:
    case SETTINGS_PAGE_UNLOADED:
    case LOGIN_PAGE_UNLOADED:
    case REGISTER_PAGE_UNLOADED:
      return { ...state, viewChangeCounter: state.viewChangeCounter + 1 };
    case ASYNC_START:
      return { ...state, inProgress: true }
    case ASYNC_END:
      return { ...state, inProgress: false }
    case CHANGE_DATE_STRINGS:
      return { ...state, date_from: action.date_from, date_to: action.date_to }
    case GENERATE_SIGNATURE:
      return {
        ...state,
        signature: action.error ? null : action.payload.signature,
        errors: action.error ? action.payload.error : null,
      }
    case CONTRACT_CREATE:
    case CONTRACT_UPDATE:
      return {
        ...state,
        redirectTo: action.error ? null : '/contracts'
      };
    case MASTER_ACCOUNT_CREATE:
    case MASTER_ACCOUNT_UPDATE:
    case MASTER_ACCOUNT_MINT:
      return {
        ...state,
        redirectTo: action.error ? null : '/masteraccounts'
      };
    case CHAT_CHANNEL_CREATE:
    case CHAT_CHANNEL_UPDATE:
    case CHAT_CHANNEL_DELETE:
    case CHAT_POST_DELETE:
      return {
        ...state,
        redirectTo: action.error ? null : '/channels'
      };
    case RATE_CREATE:
    case RATE_UPDATE:
      return {
        ...state,
        redirectTo: action.error ? null : '/rates'
      };
    case TOKEN_CREATE:
    case TOKEN_UPDATE:
    case TOKEN_APPROVE:
    case TOKEN_REJECT:
    case TOKEN_UNPAUSE:
    case TOKEN_PAUSE:
    case TOKEN_CREATION_FEE_UPDATE:
      const codeStatus = action.error
        ? null
        : action.payload
          ? action.payload.code_status
          : null;
      return {
        ...state,
        redirectTo: action.error || codeStatus === "sent" ? null : "/tokens",
      };
    case ACCOUNT_CREATE:
      return {
        ...state,
        redirectTo: action.error ? null : `/users/${action.userkey}`
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/common.js